module.exports = __webpack_public_path__ + "img/haertel.0daab06a.jpg";